


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import { ChangePasswordDto, LoginDto } from 'admiral-core';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormError from '@/components/common/forms/FormError.vue';

export type ChangePasswordModel = {
  oldpassword: string;
  newpassword: string;
  newpasswordConfirm: string;
};

@Component({
  components: { FormError, FormInputPassword, FormInput, FormRow },
})
export default class ChangePasswordForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: ChangePasswordModel;

  @Prop({ required: true, type: Object })
  readonly errors!: ChangePasswordModel;

  onInput(key: keyof ChangePasswordDto, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: keyof LoginDto) {
    this.$emit('resetError', key);
  }
}
